import { Subject } from "rxjs";
import { ToasterMessage } from "./types";

export const toaster$ : Subject<ToasterMessage> = new Subject<ToasterMessage>()

export const hideToaster$: Subject<string> = new Subject<string>()